export default {
  getAuthHeader: function () {
    return "Basic " + this.getToken();
  },

  getToken: function () {
    return localStorage.getItem("token");
  },

  createToken: function (user) {
    var token = btoa(user.username+":"+user.password);
    this.addToken(token);
  },

  addToken: function (token) {
    localStorage.setItem("token", token);
  },

  removeToken: function () {
    return localStorage.removeItem("token")
  }

}



// WEBPACK FOOTER //
// ./src/services/AuthService.js